import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"
import ImportJobActionResult from "./Model/ImportJobActionResult"

export default function ImportJobValidateObservable(importJobID: number, poolID?:number): Observable<ImportJobActionResult> {
  const params: string = JSON.stringify({ ImportJobID: importJobID, PoolID: poolID || 0 })
  return ObservableFromFetch<ImportJobActionResult>("WorkforceImport/StartValidation", params)
}
